// VoK MUI helper functions
import pxToRem from "app/assets/theme/functions/pxToRem";

const step = {
    styleOverrides: {
        root: {
            padding: `0 ${pxToRem(6)}`,
        },
    },
};

export default step;
